import { render, staticRenderFns } from "./Boing.vue?vue&type=template&id=15b83cdf&scoped=true"
var script = {}
import style0 from "./Boing.vue?vue&type=style&index=0&id=15b83cdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b83cdf",
  null
  
)

export default component.exports